/** Platform detection needed for the install flow (and the game's rotate hint). */

/** iPhone, iPod or iPad (iPadOS reports itself as a Mac, but Macs have no touch screen). */
export function isIos(navigator: Pick<Navigator, 'userAgent' | 'maxTouchPoints'>): boolean {
  return (
    /iPhone|iPad|iPod/.test(navigator.userAgent) ||
    (/Macintosh/.test(navigator.userAgent) && navigator.maxTouchPoints > 1)
  );
}

/**
 * Running as an installed app. Our manifest asks for `fullscreen`, which an ordinary tab also
 * matches while the page itself is in fullscreen mode, hence the fullscreenElement check.
 * iOS Safari exposes `navigator.standalone` instead of display-mode media queries.
 */
export function isStandalone(win: Window): boolean {
  const matches = (mode: string) => win.matchMedia(`(display-mode: ${mode})`).matches;
  const iosStandalone = 'standalone' in win.navigator && win.navigator.standalone === true;
  return (
    iosStandalone ||
    matches('standalone') ||
    (matches('fullscreen') && win.document.fullscreenElement === null)
  );
}
